// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* IE 2026 10 25 / ODOO-348925: размер ведёт вложенный AttrGraph (высота — до низа виджета); здесь только поля и текст сообщений */\n.sg-wrap { width: 100%;\n}\n.sg-notice, .sg-warn { padding: 8px 12px; color: var(--text-color-secondary, #6b7280);\n}\n.sg-warn { font-size: 0.9em; padding: 4px 12px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
